import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2e6ab396"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mb-5" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "d-flex gap-2" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "col-md-6 text-end" }
const _hoisted_6 = {
  key: 0,
  class: "text-muted fs-7"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "row mb-5"
}
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "card-body d-flex align-items-center justify-content-between py-4" }
const _hoisted_11 = { class: "d-flex align-items-center gap-3" }
const _hoisted_12 = { class: "fw-bold fs-5" }
const _hoisted_13 = { class: "text-muted fs-7" }
const _hoisted_14 = {
  key: 1,
  class: "row mb-5"
}
const _hoisted_15 = { class: "card h-100" }
const _hoisted_16 = { class: "card-body text-center" }
const _hoisted_17 = { class: "fs-7 text-muted mb-1" }
const _hoisted_18 = { class: "fs-7 fw-normal" }
const _hoisted_19 = { class: "mt-2" }
const _hoisted_20 = { class: "row mb-5" }
const _hoisted_21 = { class: "card h-100" }
const _hoisted_22 = { class: "card-body d-flex align-items-center justify-content-between" }
const _hoisted_23 = { class: "fs-6 text-muted" }
const _hoisted_24 = { class: "fs-2 fw-bold" }
const _hoisted_25 = {
  key: 0,
  class: "fs-7 text-muted"
}
const _hoisted_26 = { class: "row mb-5" }
const _hoisted_27 = { class: "col-lg-4 mb-5" }
const _hoisted_28 = { class: "card card-flush h-100" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header py-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder text-dark" }, "Failure Rate")
  ])
], -1))
const _hoisted_30 = { class: "card-body d-flex align-items-center justify-content-center" }
const _hoisted_31 = { class: "col-lg-4 mb-5" }
const _hoisted_32 = { class: "card card-flush h-100" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header py-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder text-dark" }, "CPU & Memory")
  ])
], -1))
const _hoisted_34 = {
  key: 0,
  class: "card-body"
}
const _hoisted_35 = { class: "d-flex justify-content-around" }
const _hoisted_36 = { class: "fs-7 text-muted mt-1" }
const _hoisted_37 = { class: "col-lg-4 mb-5" }
const _hoisted_38 = { class: "card card-flush h-100" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header py-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder text-dark" }, "Requests")
  ])
], -1))
const _hoisted_40 = {
  key: 0,
  class: "card-body d-flex align-items-center justify-content-center"
}
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-12" }
const _hoisted_43 = { class: "card card-flush" }
const _hoisted_44 = { class: "card-header py-5 d-flex justify-content-between" }
const _hoisted_45 = { class: "card-title" }
const _hoisted_46 = { class: "card-label fw-bolder text-dark" }
const _hoisted_47 = {
  key: 0,
  class: "badge badge-light-danger fs-7"
}
const _hoisted_48 = { class: "card-body pt-0" }
const _hoisted_49 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_50 = { class: "table table-hover table-row-bordered align-middle gs-0 gy-3" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-50px" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px" }, "Type"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-250px" }, "Message"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px" }, "Last seen"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-end" }, "Count")
  ])
], -1))
const _hoisted_52 = { class: "text-muted" }
const _hoisted_53 = { class: "badge badge-light-danger" }
const _hoisted_54 = { class: "text-dark fs-7" }
const _hoisted_55 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_56 = { class: "text-muted fs-7" }
const _hoisted_57 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_58 = {
  class: "text-end fw-bold fs-5",
  style: {"color":"#F50242"}
}
const _hoisted_59 = {
  key: 1,
  class: "text-center text-muted py-10"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle fs-1 text-success" }, null, -1))
const _hoisted_61 = { class: "mt-3 fs-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeRanges, (range) => {
            return (_openBlock(), _createElementBlock("button", {
              key: range,
              class: _normalizeClass(["btn btn-sm", _ctx.selectedRange === range ? 'btn-primary' : 'btn-outline-light']),
              onClick: ($event: any) => (_ctx.selectRange(range))
            }, _toDisplayString(range), 11, _hoisted_4))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.lastUpdated)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Last updated: " + _toDisplayString(_ctx.lastUpdated), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "btn btn-sm btn-outline-light ms-3",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshAll && _ctx.refreshAll(...args))),
          disabled: _ctx.loading
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["bi bi-arrow-clockwise", { 'spin': _ctx.loading }])
          }, null, 2),
          _createTextVNode(" Refresh ")
        ], 8, _hoisted_7)
      ])
    ]),
    (_ctx.planData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: _normalizeClass(["card", {
            'border-success': _ctx.planData.overallStatus === 'healthy',
            'border-warning': _ctx.planData.overallStatus === 'warning',
            'border-danger': _ctx.planData.overallStatus === 'critical',
          }])
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fs-1", _ctx.statusIcon(_ctx.planData.overallStatus)])
                  }, null, 2),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.planData.planName) + " (" + _toDisplayString(_ctx.planData.sku) + ")", 1),
                    _createElementVNode("div", _hoisted_13, [
                      _createTextVNode(" Status: "),
                      _createElementVNode("span", {
                        class: _normalizeClass([_ctx.statusTextClass(_ctx.planData.overallStatus), "fw-semibold text-uppercase"])
                      }, _toDisplayString(_ctx.planData.overallStatus), 3)
                    ])
                  ])
                ])
              ])
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.planData && _ctx.planData.metrics)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planData.metrics, (metric) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-4 col-lg-2 mb-4",
              key: metric.name
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.formatMetricName(metric.name)), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["fs-2 fw-bold", _ctx.statusTextClass(metric.status)])
                  }, [
                    _createTextVNode(_toDisplayString(metric.value) + " ", 1),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(metric.unit), 1)
                  ], 2),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", {
                  'badge-light-success': metric.status === 'green',
                  'badge-light-warning': metric.status === 'yellow',
                  'badge-light-danger': metric.status === 'red',
                }])
                    }, _toDisplayString(metric.status), 3)
                  ])
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.healthCards, (card) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-md-3 mb-4",
          key: card.label
        }, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_23, _toDisplayString(card.label), 1),
                _createElementVNode("div", _hoisted_24, _toDisplayString(card.value), 1),
                (card.sub)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(card.sub), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("i", {
                class: _normalizeClass([card.icon, "fs-1"]),
                style: {"color":"#F50242"}
              }, null, 2)
            ])
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            (_ctx.healthData)
              ? (_openBlock(), _createBlock(_component_apexchart, {
                  key: 0,
                  type: "radialBar",
                  height: "280",
                  options: _ctx.failureRateOptions,
                  series: [_ctx.healthData.failureRate || 0]
                }, null, 8, ["options", "series"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          (_ctx.planData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cpuMemMetrics, (m) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "text-center",
                      key: m.name
                    }, [
                      _createVNode(_component_apexchart, {
                        type: "radialBar",
                        height: "180",
                        options: _ctx.gaugeOptions(m.name, m.status),
                        series: [m.value]
                      }, null, 8, ["options", "series"]),
                      _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.formatMetricName(m.name)), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          (_ctx.healthData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createVNode(_component_apexchart, {
                  type: "pie",
                  height: "280",
                  options: _ctx.requestsPieOptions,
                  series: _ctx.requestsPieSeries
                }, null, 8, ["options", "series"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("h3", _hoisted_45, [
              _createElementVNode("span", _hoisted_46, "Exceptions (" + _toDisplayString(_ctx.selectedRange) + ")", 1)
            ]),
            (_ctx.exceptionsData)
              ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.exceptionsData.exceptions.length) + " types ", 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_48, [
            (_ctx.exceptionsData && _ctx.exceptionsData.exceptions.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createElementVNode("table", _hoisted_50, [
                    _hoisted_51,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exceptionsData.exceptions, (ex, idx) => {
                        return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                          _createElementVNode("td", _hoisted_52, _toDisplayString(idx + 1), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_53, _toDisplayString(ex.type), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_54, _toDisplayString(ex.message), 1),
                            (ex.problemId)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_55, "ID: " + _toDisplayString(ex.problemId), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_56, [
                            _createTextVNode(_toDisplayString(_ctx.formatDate(ex.lastSeen)) + " ", 1),
                            (ex.firstSeen)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_57, "First: " + _toDisplayString(_ctx.formatDate(ex.firstSeen)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_58, _toDisplayString(ex.count), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  _hoisted_60,
                  _createElementVNode("div", _hoisted_61, "No exceptions in the last " + _toDisplayString(_ctx.selectedRange), 1)
                ]))
          ])
        ])
      ])
    ])
  ]))
}